module.exports = __webpack_public_path__ + "img/image_loading.f3dc1cb5.svg";